import { CourseOrderItem, ForJointCaseOrders } from 'share/domain/course'
import { ActiveCase } from 'reducers/activecase/activecaseSlice'
import { ActiveCourse } from 'reducers/activecourse/activecourseSlice'
import { ApolloQueryResult } from '@apollo/client'
import { client } from 'app/App'
import {
  GET_MANUAL_UPLOAD_CERT_DATA,
  GetManualUploadCertDataVariables,
  GetManualUploadCertDataResponse
} from 'share/queries/documents'

export function shouldNavigateToVerifyPrimaryInformation(
  course: CourseOrderItem
): string | null {
  if (!course.verifiedDetails) {
    return '/dashboard/courses/verify'
  }
  return null
}

function getFirstCourseForJointCaseOrders(
  isDebtor1: boolean,
  activeCase: ActiveCase
): number | null | undefined {
  if (isDebtor1) {
    return activeCase.matter?.debtor1FirstCourseForJointCaseOrders
  } else {
    return activeCase.matter?.debtor2FirstCourseForJointCaseOrders
  }
}

function getSecondCourseForJointCaseOrders(
  isDebtor1: boolean,
  activeCase: ActiveCase
): number | null | undefined {
  if (isDebtor1) {
    return activeCase.matter?.debtor1SecondCourseForJointCaseOrders
  } else {
    return activeCase.matter?.debtor2SecondCourseForJointCaseOrders
  }
}

export function shouldNavigateToVerifySpouseInformation(
  isDebtor1: boolean,
  course: CourseOrderItem,
  activeCase: ActiveCase,
  activeCourse: ActiveCourse
): string | null {
  if (activeCase.matter) {
    if (activeCourse.activeTab === 'first') {
      if (
        activeCase.matter.isJoint &&
        getFirstCourseForJointCaseOrders(isDebtor1, activeCase) &&
        getFirstCourseForJointCaseOrders(isDebtor1, activeCase) ===
          ForJointCaseOrders.OneCourseTakingTogether
      ) {
        if (!course.verifiedCoDebtorDetails) {
          return '/dashboard/courses/verify-spouse'
        }
      }
    } else {
      if (
        activeCase.matter.isJoint &&
        getSecondCourseForJointCaseOrders(isDebtor1, activeCase) &&
        getSecondCourseForJointCaseOrders(isDebtor1, activeCase) ===
          ForJointCaseOrders.OneCourseTakingTogether
      ) {
        if (!course.verifiedCoDebtorDetails) {
          return '/dashboard/courses/verify-spouse'
        }
      }
    }
  }
  return null
}

export function shouldNavigateToDisclosureAgreement(
  course: CourseOrderItem
): string | null {
  if (!course.acceptedDisclosureAgreement) {
    return '/dashboard/courses/course-disclosure-agreement'
  }
  return null
}

export function shouldNavigateToCourseInstructions(
  course: CourseOrderItem
): string | null {
  if (!course.shownCourseInstructions) {
    return '/dashboard/courses/course-instructions'
  }
  return null
}

export function mainCoursePagePath(): string {
  return '/dashboard/courses'
}

export async function getManualUploadCertData(
  input: GetManualUploadCertDataVariables
): Promise<ApolloQueryResult<GetManualUploadCertDataResponse>> {
  return client.query<
    GetManualUploadCertDataResponse,
    GetManualUploadCertDataVariables
  >({
    query: GET_MANUAL_UPLOAD_CERT_DATA,
    variables: input,
    fetchPolicy: 'no-cache'
  })
}
